//Componentes generales
import React, { useEffect, useRef, useState } from "react";
import DropDownPicker from "../DropDownPicker/DropDownPicker";
import moment from "moment";
import SelectList from "../SelectList/SelectList";
import Swal from "sweetalert2";

//Tipos de Estado
import { STATES_COMPROBANTE } from "../../utils/states";

//Permisos
import { VER_USUARIOS } from "../../utils/permisos";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

// Estilos
import "./AddFilter.css";

/* 
    Componente de vista dialogo de filtros.
        Donde currentUser es el usuario en sesión.
              usuarios contiene todos los usuarios disponibles.
              cerrar es la función encargada de ocultar el dialogo.
              filtro es la variable del context que define que comprobantes se muestran.
              aplicarFiltros es la función del context que setea el filtro del context.
              workspace es la variable que fltra cuando el usuario se mueve entre workspaces de estados (Ya definidos: Pendientes y Disponibles).
              checkPermisos es la función de la vista que chequea los permisos del usuario en sesión con el enviado por parametro.
*/
function AddFilter({
  usuario,
  proveedores,
  cerrar,
  filtro,
  aplicarFiltros,
  workspace,
  setFiltrosModificados
}) {
  const [filterEstado, setFilterEstado] = useState(filtro.filtrosEstado);
  const [filterRango, setFilterRango] = useState(filtro.filtrosRango);
  const [statesAvailable, setStatesAvailable] = useState(STATES_COMPROBANTE);
  const [selectedProv, setSelectedProv] = useState(
    filtro.filtrosEstado.tDocAbmProvider
  );
  //State de la lista de proveedores con opción por defecto agregada
  const [proveedoresModificado, setProveedoresModificado] = useState([]);
  //States de selección de "Todos" en usuario.
  /* const [allUsers, setAllUsers] = useState((filtro.filtrosEstado.userName.length === usuarios.length)); */

  const importeDesdeRef = useRef(null);
  const importeHastaRef = useRef(null);

  useEffect(() => {
    setProveedoresModificado([
      {
        nroCta: "",
        nombre: "-- SELECCIONAR TODOS LOS PROVEEDORES --",
      },
      ...proveedores,
    ]);
  }, []);

  const handlerClickState = (bool, state) => {
    const temp = filterEstado.state;
    if (bool && !temp.includes(state)) {
      temp.push(state);
      setFilterEstado({ ...filterEstado, state: temp });
    } else {
      const temp2 = temp.filter((f) => f !== state);
      setFilterEstado({ ...filterEstado, state: temp2 });
    }
  };

  const handlerClickProveedores = (value) => {
    setSelectedProv([value.value]);
    if (value.value.nroCta == "") {
      proveedores.push({ nroCta: "", nombre: "" });
      setFilterEstado({
        ...filterEstado,
        tDocAbmProvider: proveedores.map((p) => ({
          nroCta: p.nroCta,
          nombre: p.nombre,
        })),
      });
    } else {
      setFilterEstado({
        ...filterEstado,
        tDocAbmProvider: [
          { nroCta: value.value.nroCta, nombre: value.value.nombre },
        ],
      });
    }
  };

  const handlerChangeFecalt = (e) => {
    const [day, month, year] = e.target.value.split("/");
    const dateISOFormat = `${year}-${month}-${day}`;
    const casteo = new Date(dateISOFormat);
    const nombrePropiedad = e.target.name == "fecAltDesde" ? "desde" : "hasta";

    setFilterRango({
      ...filterRango,
      fecAlt: { ...filterRango.fecAlt, [nombrePropiedad]: casteo },
    });
  };

  const handlerChangeDateOfIssue = (e) => {
    const [day, month, year] = e.target.value.split("/");
    const dateISOFormat = `${year}-${month}-${day}`;
    const casteo = new Date(dateISOFormat);
    const nombrePropiedad =
      e.target.name == "dateOfIssueDesde" ? "desde" : "hasta";

    setFilterRango({
      ...filterRango,
      dateOfIssue: { ...filterRango.dateOfIssue, [nombrePropiedad]: casteo },
    });
  };

  const handlerChangeImporte = (e) => {
    const nombrePropiedad = e.target.name == "importeDesde" ? "desde" : "hasta";

    setFilterEstado({
      ...filterEstado,
      importe: {
        ...filterEstado.importe,
        [nombrePropiedad]: parseFloat(e.target.value),
      },
    });
  };

  const handlerChangeOcApl = (selectedOptions) => {
    setFilterEstado({
      ...filterEstado,
      ocsApl: selectedOptions || [],
    });
  };

  const handlerClickUsers = (bool, user) => {
    if (bool) {
      setFilterEstado((filterEstadoAnterior) => ({
        ...filterEstadoAnterior,
        userName: [...filterEstado.userName, user],
      }));
    } else {
      setFilterEstado((filterEstadoAnterior) => ({
        ...filterEstadoAnterior,
        userName: filterEstado.userName.filter((i) => i !== user),
      }));
    }
  };

  const handlerAplicaFiltros = async (estado, rango) => {
    let validation = "";
    if (new Date(rango.fecAlt.desde) > new Date(rango.fecAlt.hasta)) {
      validation =
        "La fecha de alta -Desde- no puede ser mayor a la fecha de alta -Hasta-";
    }
    if (new Date(rango.dateOfIssue.desde) > new Date(rango.dateOfIssue.hasta)) {
      validation =
        "La fecha de emisión -Desde- no puede ser mayor a la fecha de emisión -Hasta-";
    }
    if (estado.importe.hasta !==null && estado.importe.desde > estado.importe.hasta) {
      validation = "El importe -Desde- no puede ser mayor al importe -Hasta-";
    }

    if (validation == "") {
      setFiltrosModificados(true);
      // Esperar a que se apliquen los filtros antes de cerrar
      await aplicarFiltros({ filterEstado: estado, filterRango: rango });
      cerrar(null);
    } else {
      Swal.fire({
        title: "Hubo un error!",
        text: validation,
        icon: "error",
      });
    }
  };

  return (
    <div className="container-gr-filter">
      <div className="label-filter-icon-r">
        <div className="filter-title-r">Filtros</div>
        <div className="filter-icon-r">
          <FontAwesomeIcon icon={faXmark} onClick={() => cerrar(null)} />
        </div>
      </div>
      <div>
        <div className="container-gr-filter-fil">
          <div
            style={{
              display: "flex",
              borderWidth: 1,
              justifyContent: "space-between",
            }}
          >
            <div className="container-gr-subtitles">Estados</div>

            {workspace.todos === 1 ? (
              <button
                className="button-todos"
                style={{ boxShadow: "4px 5px 5px -3px rgba(0,0,0,0.23)" }}
                onClick={() => {
                  setFilterEstado({
                    ...filterEstado,
                    state:
                      filterEstado.state.length === STATES_COMPROBANTE.length ? [] : STATES_COMPROBANTE,
                  });
                }}
              >
                {filterEstado.state.length === STATES_COMPROBANTE.length
                  ? "Deseleccionar Todos"
                  : "Seleccionar Todos"}
              </button>
            ) : (
              <div></div>
            )}
          </div>

          <div className="filter-container-states">
            <div className="filter-container-states-gr">
              <div style={{ display: "flex" }}>
                {statesAvailable.map(function (st, indexS) {
                  if (workspace.pendientes || workspace.autorizados) {
                    return (
                      <div className="container-states-f" key={indexS}>
                        <input
                          type="checkbox"
                          id={`state-${indexS}`}
                          name="states"
                          value={st}
                          disabled
                          defaultChecked={
                            filterEstado.state.includes(st) ? true : false
                          }
                          onClick={(bool) =>
                            handlerClickState(bool.target.checked, st)
                          }
                        />
                        <label
                          htmlFor={`state-${indexS}`}
                          className="filter-priority-item-label"
                        >
                          {st}
                        </label>
                      </div>
                    );
                  } else {
                    return (
                      <div className="container-states-f" key={indexS}>
                        <input
                          type="checkbox"
                          name={`state-${st}`}
                          value={st}
                          checked={
                            filterEstado.state.includes(st) ? true : false
                          }
                          onChange={(bool) =>
                            handlerClickState(bool.target.checked, st)
                          }
                        />
                        <label className="filter-priority-item-label">
                          {st}
                        </label>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>

        {proveedores && proveedores.length > 0 && (
          <div id="reqs-sectors" className="container-gr-filter-fil">
            <div
              style={{
                display: "flex",
                borderWidth: 1,
                justifyContent: "space-between",
              }}
            >
              <div className="container-gr-subtitles">Proveedores</div>
            </div>
            <div className="filter-container-states">
              <div>
                <SelectList
                  options={[
                    ...proveedoresModificado.map((p) => ({
                      value: { nroCta: p.nroCta, nombre: p.nombre },
                      label: p.nroCta ? p.nroCta + " - " + p.nombre : p.nombre,
                    })),
                  ]}
                  handleChange={handlerClickProveedores}
                  property="Proveedor"
                  valueAux={
                    selectedProv.length > 1 || selectedProv[0].nroCta === ""
                      ? {
                          label: "-- SELECCIONAR TODOS LOS PROVEEDORES --",
                          value: "",
                        }
                      : {
                          label:
                            selectedProv[0].nroCta +
                            " (" +
                            selectedProv[0].nombre +
                            ")",
                          value: {
                            nroCta: selectedProv[0].nroCta,
                            nombre: selectedProv[0].nombre,
                          },
                        }
                  }
                  emptyInputs={[]}
                  disabled={usuario.nroCta !== null && usuario.nroCta !==""}
                  isFilter={true}
                  styles={{
                    additionalStyleDivSelectList: {
                      alignItems: "center",
                      gap: "0.5rem",
                    },
                    fontStyleTitle: {
                      fontSize: "1.5rem",
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Fecha de Alta</div>
          <div className="filter-container-date">
            <div className="filter-date-item">
              <div className="filter-date-item-label">Desde</div>
              <input
                type="date"
                className="label-AddFilter-fecha"
                name="fecAltDesde"
                defaultValue={moment(filterRango.fecAlt.desde).format(
                  "YYYY-MM-DD"
                )}
                onChange={(e) => handlerChangeFecalt(e)}
              />
            </div>
            <div className="filter-date-item">
              <div className="filter-date-item-label">Hasta</div>
              <input
                type="date"
                name="fecAltHasta"
                className="label-AddFilter-fecha"
                defaultValue={moment(filterRango.fecAlt.hasta).format(
                  "YYYY-MM-DD"
                )}
                onChange={(e) => handlerChangeFecalt(e)}
              />
            </div>
          </div>
        </div>
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Fecha de Emisión</div>
          <div className="filter-container-date">
            <div className="filter-date-item">
              <div className="filter-date-item-label">Desde</div>
              <input
                type="date"
                className="label-AddFilter-fecha"
                name="dateOfIssueDesde"
                defaultValue={moment(filterRango.dateOfIssue.desde).format(
                  "YYYY-MM-DD"
                )}
                onChange={(e) => handlerChangeDateOfIssue(e)}
              />
            </div>
            <div className="filter-date-item">
              <div className="filter-date-item-label">Hasta</div>
              <input
                type="date"
                className="label-AddFilter-fecha"
                name="dateOfIssueHasta"
                defaultValue={moment(filterRango.dateOfIssue.hasta).format(
                  "YYYY-MM-DD"
                )}
                onChange={(e) => handlerChangeDateOfIssue(e)}
              />
            </div>
          </div>
        </div>
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Importe</div>
          <div className="filter-container-date">
            <div className="filter-date-item">
              <div className="filter-date-item-label">Desde</div>
              <div className="input-with-symbol">
                <span
                  className="currency-symbol"
                  onClick={() => importeDesdeRef.current.focus()}
                >
                  $
                </span>
                <input
                  /*                 onFocus={(e) => setOnFocus(e.target.name)}
                onBlur={() => setOnFocus("")}*/
                  ref={importeDesdeRef}
                  type="number"
                  defaultValue={
                    !isNaN(filtro.filtrosEstado.importe.desde)
                      ? filtro.filtrosEstado.importe.desde
                      : ""
                  }
                  name="importeDesde"
                  onChange={(e) => handlerChangeImporte(e)}
                  placeholder="0.00"
                  className="label-AddFilter-importe"
                />
              </div>
            </div>
            <div className="filter-date-item">
              <div className="filter-date-item-label">Hasta</div>
              <div className="input-with-symbol">
                <span
                  className="currency-symbol"
                  onClick={() => importeDesdeRef.current.focus()}
                >
                  $
                </span>
                <input
                  /*                 onFocus={(e) => setOnFocus(e.target.name)}
                onBlur={() => setOnFocus("")}*/
                  ref={importeHastaRef}
                  type="number"
                  defaultValue={
                    !isNaN(filtro.filtrosEstado.importe.hasta)
                      ? filtro.filtrosEstado.importe.hasta
                      : ""
                  }
                  name="importeHasta"
                  onChange={(e) => handlerChangeImporte(e)}
                  placeholder="0.00"
                  className="label-AddFilter-importe"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container-gr-filter-fil">
          <div className="container-gr-subtitles">Orden de Compra</div>
          <div className="filter-container-date">
            <div className="filter-date-item">
              <div className="input-with-symbol">
                <DropDownPicker
                  isCreatable
                  numberOnly
                  value={filterEstado.ocsApl}
                  onChange={handlerChangeOcApl}
                  placeholder="Escriba un número y presione Enter"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-filter-btn">
        <div
          className="filter-btn"
          onClick={() => handlerAplicaFiltros(filterEstado, filterRango)}
        >
          Aplicar Filtros
        </div>
      </div>
    </div>
  );
}

export default AddFilter;